import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const includes = ['5 Master Workbooks — 300 pages', '4 Expert Bonuses — 160+ pages', '460+ pages of print-ready content', 'Instant download — printable PDF', 'Designed to support key high school chemistry concepts and adaptable to different teaching programs.', 'Available worldwide', 'One-time payment — no subscription', '7-day money-back guarantee'];
export function ClosingBlock() {
  return <section id="closing" className="w-full scroll-mt-20 bg-ink px-5 py-14 sm:py-24" data-id="element-41" data-mp="1w0kusbtps6an">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-42" data-mp="1rypvtdz9a501">
        <h2 className="font-serif-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-43" data-mp="1i2w8r0nwut40">
          Your lessons prepared. Your students engaged. Your Mondays transformed.
        </h2>
        <p className="mt-4 text-lg font-medium text-cobalt sm:text-xl" data-id="element-44" data-mp="3nrle063wrutb">
          Visual Chemistry™ The Complete Chemistry Teaching System
        </p>

        <ul className="mt-8 grid w-full max-w-md gap-3 text-left" data-id="element-45" data-mp="3dwbcrklc3rgl">
          {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-46" data-mp="3iv4qne4j9kha">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cobalt/20 text-cobalt" data-id="element-47" data-mp="aet5pfddyoh8">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-48" data-mp="fcl8x5jhdx0q" />
              </span>
              <span className="text-sm leading-relaxed text-white/85" data-id="element-49" data-mp="h5c4srinn0n">{item}</span>
            </li>)}
        </ul>

        <div className="mt-10 flex flex-col items-center" data-id="element-50" data-mp="5dvmr0kjxqeo">
          <span className="text-lg font-medium text-white/40 line-through sm:text-xl" data-id="element-51" data-mp="2l630uahe63ag">$423 USD</span>
          <span className="font-serif-display text-[52px] font-bold leading-none text-cobalt sm:text-7xl" data-id="element-52" data-mp="2q67aphnsnzrp">
            $27 USD
          </span>
        </div>

        <motion.a href="#get-access" animate={{
        y: [0, -2, 0],
        scale: [1, 1.015, 1]
      }} whileHover={{
        scale: 1.025,
        boxShadow: '0 16px 34px -10px rgba(22, 163, 74, 0.7)'
      }} whileTap={{
        scale: 0.98
      }} transition={{
        y: {
          duration: 2.2,
          ease: 'easeInOut',
          repeat: Infinity
        },
        scale: {
          duration: 2.2,
          ease: 'easeInOut',
          repeat: Infinity
        },
        type: 'spring',
        stiffness: 400,
        damping: 22
      }} className="mt-9 flex min-h-[58px] w-full max-w-md items-center justify-center gap-2 rounded-[10px] bg-cta-green px-6 py-4 text-base font-extrabold tracking-tight text-white shadow-lg shadow-cta-green/40 sm:text-lg" data-id="element-53" data-mp="wp1hu301qhhy">
          START TEACHING WITH VISUAL CHEMISTRY
        </motion.a>
        <p className="mt-3 text-xs text-white/60" data-id="element-54" data-mp="1y9y9xyb3r7ro">
          Instant Access · One-Time Payment · Worldwide · 7-Day Guarantee
        </p>
      </motion.div>
    </section>;
}